import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
/* Init FontAwesome library */
import { faEllipsisVertical,faHandsClapping, faEye, faEyeSlash, faEllipsisV, faSpinner, faPowerOff, faHamburger, faBowlingBall, faMoneyBillAlt, faJedi, faMedal, faPlusCircle, faTicketAlt, faUmbrellaBeach, faDumbbell, faGift, faAppleAlt, faBell, faUsers, faChevronLeft, faChevronRight, faEnvelope, faTimes, faCloudShowersHeavy, faCogs, faTrophy, faSmileBeam, faHeart, faSeedling, faRocket } from '@fortawesome/free-solid-svg-icons';

library.add(faPowerOff, faHamburger, faBowlingBall, faMoneyBillAlt);
library.add(faJedi, faMedal, faPlusCircle, faTicketAlt, faAppleAlt, faBell, faRocket, faSeedling);
library.add(faUmbrellaBeach, faDumbbell, faGift, faUsers, faChevronLeft, faChevronRight, faHeart);
library.add(faEnvelope, faTimes, faCloudShowersHeavy, faCogs, faTrophy, faSmileBeam, faSpinner);
library.add(faEllipsisV, faEye, faEyeSlash, faHandsClapping,faEllipsisVertical);
Vue.component('font-awesome-icon', FontAwesomeIcon);
